
import { throwError as observableThrowError, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';

@Injectable()
export class ProfileService {
    constructor(private http: Http) { }

    getProfile(cid: string) {
        let url = `${environment.api.serviceurl}` + "GetUserProfile?cid=" + cid;
        return this.http.get(url).pipe(
            map((response: Response) => {
                let abc = response.json();
                return abc.GetUserProfileResult;
            }));
    }

    getProfilePost(customerId: string, sKey: string): Observable<any> {
        let url = `${environment.api.serviceurl}` + "getUserProfile";
        let orderData = customerId;
        let headers = new Headers();
        headers.set('Content-Type', 'application/json');
        headers.set("authinfo", sKey);
        let data = orderData;
        let options = new RequestOptions({ headers: headers });
        return this.http.post(url, data, options).pipe(
            map(this.extractData),
            catchError(this.handleError),);
    }

    private extractData(res: Response) {
        let body = res.json();
        let jsonbody = JSON.parse(body.orderid);
        return jsonbody || {};
    }

    private handleError(error: any) {
        let errMsg = '';
        if (error.message) {
            errMsg = error.message;
        } else {
            errMsg = error.status ? '${error.status} - ${error.statusText}' : 'Server error';
        }
        return observableThrowError(errMsg);
    }
}